import AbstractListenerAction from "../../listen/AbstractListenerAction";

export default abstract class AbstractWebRtcListenerAction extends AbstractListenerAction {

}